<div>
  <div
    matTooltip="{{ getTitle() }}"
    matTooltipClass="info-tooltip"
    aria-label="A button that plays the tournament"
    (click)="disableClick($event)"
  >
    <button
      *ngIf="!comingSoon"
      mat-flat-button
      color="primary"
      (click)="onClick($event)"
      [ngClass]="{
        'mat-button-loading':
          passesLoaded !== null &&
          passesLoaded !== undefined &&
          !passesLoaded &&
          isLoggedIn
      }"
      [disabled]="isDisabledToPlay()"
      data-ga-value="play-button"
    >
      <div>
        <span *ngIf="!eventSchedule.retired && !isCompleted">
          Play - <span *ngIf="playButtonText">{{ playButtonText }} </span>
          <fz-currency
            *ngIf="!playButtonText"
            [value]="eventSchedule.entryAmount"
          ></fz-currency
        ></span>
        <span *ngIf="eventSchedule.retired">Retired</span>
        <span *ngIf="isCompleted">Completed</span>
      </div>
    </button>
  </div>
  <fz-subscribe-button
    *ngIf="comingSoon"
    [eventSchedule]="eventSchedule"
    [eventPrototypeUuid]="tournament.uuid"
    [currentUser]="currentUser"
  ></fz-subscribe-button>
</div>
